// extracted by mini-css-extract-plugin
export default {"questionText":"bf_c9","info":"bf_db","question":"bf_dc"};